module.exports = __webpack_public_path__ + "media/images/svg/clients/14-896aae6ccb3c585dbeead380351c0186.svg";